import {institutionCountry} from 'web-app/react/entities/institutions/selectors';
import useTypedSelector from 'web-app/react/hooks/use-typed-selector';
import type {CoreCountryType} from 'web-app/react/bookings-finance/contexts/currency-formatter-context/types/core-country.type';

/**
 * Hook to get the user's site country from the store based on context ID
 * @param userContextId - Only support institutionId as userContextId but should be extended to support other organisationId
 * @returns the country of the site
 */

export function useGetUserSiteCountryFromStore({userContextId}: {userContextId: string}) {
    const siteCountry = useTypedSelector(state => institutionCountry(state, {institutionId: userContextId ?? ''}));

    return (siteCountry ?? 'US') as CoreCountryType;
}
